import React from "react";
import styles from "../../../assets/stylesheets/blog/FarmmodeBlogDetail.module.css";
import MainImg from "../../../assets/img/blog/april/MainBestFarm.webp"; 

import Grindstone from "../../../assets/img/blog/april/Grindstone.avif"; 
import Kustermans from "../../../assets/img/blog/april/Kustermans.webp"; 
import Pingles from "../../../assets/img/blog/april/Pingles.webp"; 
import SarahGrey from "../../../assets/img/blog/april/SarahGrey.webp"; 
import TASC from "../../../assets/img/blog/april/TASC.webp"; 

const APRIL_FARMS = [
  {
    farms: [
      {
        name: "1. Grindstone Creek Farm",
        img: Grindstone,
        subTitle: "Authentic farmstay experience in a charming barn loft.",
        description: "If you’re dreaming of a slow, meaningful escape from the city this spring, Grindstone Creek Farm is a must-visit. Tucked away in Burlington, this small family-run farm blends sustainable agriculture with warm hospitality, making it one of the best farmstays in Ontario. Spanning six acres, Grindstone Creek is home to a variety of animals — including horses, goats, pigs, chickens, and ducks. Visitors can enjoy hands-on animal feeding tours, pet friendly livestock, and explore peaceful farm trails surrounded by nature.",
        location: "1450 Old York Road, Burlington, ON",
        website: "Grindstone Creek Farm",
        webUrl: "https://www.grindstonecreekfarmburlington.com/",
        details: [
          { label: "Farmciti Pick! Moments We Loved", value: "Authentic farmstay experience in a charming barn loft | Family-friendly animal encounters and guided tours | Sustainable and ethical farming philosophy | Beautiful countryside atmosphere just 45 minutes from Toronto" }
        ]
      },
      {
        name: "2. Kustermans Adventure Farm",
        img: Kustermans,
        subTitle: "The ultimate spring family day trip in Ontario.",
        description: "Looking for the ultimate spring family day trip in Ontario? Look no further than Kustermans Adventure Farm — a massive 50+ attraction destination packed with fun, learning, and seasonal events. Located just outside London, Ontario, this adventure farm is designed to keep kids smiling and parents relaxed. The season officially kicks off on April 12 with their annual Easter Festival, a can’t-miss event filled with egg hunts, meet-and-greets with the Easter Bunny, and tasty festive treats.",
        location: "23188 Springwell Road, Mount Brydges, ON",
        website: "Kustermans Adventure Farm",
        webUrl: "https://www.kustermans.ca/",
        details: [
          { label: "Note", value: "The Easter Festival starts April 12 — advance tickets recommended as weekends fill up quickly!" },
          { label: "Farmciti Pick! Moments We Loved", value: "Over 50+ attractions across the farm | Action-packed Easter Festival kicking off April 12 | Seasonal berry & sunflower picking | Perfect for birthdays, school trips, and spring break fun" }
        ]
      },
      {
        name: "3. TASC Tulip Pick Farm",
        img: TASC,
        subTitle: "Welcome to a true floral paradise.",
        description: "Welcome to a true floral paradise — TASC Tulip Pick Farm is where spring dreams come to life! Just minutes from the heart of Niagara-on-the-Lake, this breathtaking farm stretches across 55 acres and showcases over 3 million tulips in bloom, representing 175+ vibrant varieties. It’s one of the largest tulip farms in Ontario — and arguably the most photogenic. Surrounded by Niagara’s wine country, TASC makes for the perfect spring weekend getaway with family, friends, or even a romantic picnic among the petals.",
        location: "1173 Line 3 Road, Niagara-on-the-Lake, ON",
        website: "TASC Tulip Farm",
        webUrl: "https://tascllc.com/en/",
        details: [
          { label: "Note", value: "The tulip farm typically opens mid-to-late April, depending on bloom timing. Be sure to check their social media or website for real-time updates on the flowers!" },
          { label: "Farmciti Pick! Moments We Loved", value: "Massive tulip fields with 175+ unique colors & styles | Ideal for family photos, proposals, and spring content creation | Easy access, parking, and kid-friendly layout | Peaceful escape just a short drive from Toronto or Niagara Falls" }
        ]
      },
      {
        name: "4. Pingle's Farm Market",
        img: Pingles,
        subTitle: "A classic spring farm adventure near Toronto.",
        description: "If you’re dreaming of a classic spring farm adventure near Toronto, Pingle’s Farm Market should be at the top of your list. This beloved, family-run destination is open year-round, but April is when the farm truly shines — thanks to its vibrant Pick-Your-Own Tulip Experience and festive Easter activities. Stroll through rows of blooming tulips, handpick a custom bouquet, and capture those perfect spring photo moments. Kids will love the Easter scavenger hunts, tractor rides, and wide-open play zones.",
        location: "1805 Taunton Road East, Hampton, ON",
        website: "Pingle's Farm Market",
        webUrl: "https://pinglesfarmmarket.com/",
        details: [
          { label: "Note", value: "The Easter Festival and Tulip Experience typically run mid-to-late April. Check their event calendar or socials for bloom updates and ticket info." },
          { label: "Farmciti Pick! Moments We Loved", value: "Stunning U-Pick tulip fields (ideal for photos + souvenirs) | Easter Festival with games, scavenger hunts, and tractor rides | Delicious baked goods, fresh produce, and artisan treats | Great location just east of the GTA — perfect for a day trip!" }
        ]
      },
      {
        name: "5. Sarah Grey Tulip Pick Farm",
        img: SarahGrey,
        subTitle: "A calm and scenic tulip experience in Ontario.",
        description: "If you’re searching for a calm and scenic tulip experience in Ontario, Sarah Grey Tulip Pick Farm is your go-to spring destination. Located in the quiet town of Fenwick, this family-run tulip farm stretches across 23 acres and features over 1.5 million tulip bulbs in full bloom — creating a dreamy, colorful landscape perfect for slowing down and soaking in nature. What makes Sarah Grey stand out is its dedication to accessibility and comfort. The farm is designed with wide, stroller- and wheelchair-friendly paths, making it an ideal destination for families with small children, seniors, or anyone seeking a gentler pace.",
        location: "1415 Balfour Street, Fenwick, ON",
        website: "Sarah Grey Tulip Farm",
        webUrl: "https://www.sarahgrey.ca/", // Placeholder guess
        details: [
          { label: "Note", value: "Tulip season typically begins late April through early May, depending on weather. Check their site or socials for bloom announcements and opening day updates!" },
          { label: "Farmciti Pick! Moments We Loved", value: "A relaxed, scenic vibe — perfect for couples, grandparents & quiet getaways | Fully accessible tulip fields for strollers & wheelchairs | Locally owned with a curated, community feel | Workshops & seasonal pop-up markets with regional vendors" }
        ]
      }
    ]
  }

];

export default function April() {
  return (
    <div className={styles.page}>

      {/* Top meta like blogTO */}
      <div className={styles["top-meta"]}>
        {/* <span className={styles["category-name"]}>Best Farm</span>
        <span className={styles["sep"]}>•</span>
        <span>FarmCiti News</span>
        <span className={styles["sep"]}>•</span>
        <span>Posted Apr 3, 2025</span> */}
      </div>

      {/* Main Title */}
      <h1 className={styles["title"]}>The Best Farm to visit in April 2025</h1>

      {/* Hero Image */}
      <div className={styles["hero-wrap"]}>
        <img
          className={styles["hero"]}
          src={MainImg}
          alt="Best Farms"
        />
      </div>

      <div className={styles["lead-section"]}>
        <p><strong>Looking for the best family-friendly farms in Ontario this April?</strong><br />
        Whether you’re planning a weekend escape from the city, seeking a vibrant tulip farm, or searching for the perfect Easter Festival for kids — these five farms offer unforgettable spring farm experiences just a drive away.</p>
        <p>Here are five must-visit farms this April that promise memorable experiences for all ages:</p>
      </div>

      <div className={styles["jump-links"]}>
        {/* Simple jump link placeholder if needed, or removing if not grouped by region */}
      </div>

      {APRIL_FARMS.map((region, idx) => (
        <div key={idx}>
          {region.region && (
            <>
            <h2 className={styles["region-title"]}>{region.region}</h2>
            <hr className={styles["region-divider"]} />
            </>
          )}
          
          {region.farms.map((farm, fIdx) => (
            <div key={fIdx} className={styles["farm-section"]}>
              <h3 className={styles["farm-name"]}>{farm.name}</h3>
              <hr className={styles["region-divider"]} />
              
              {farm.img && <img src={farm.img} alt={farm.name} className={styles["farm-image"]} />}
              
              <div className={styles["farm-description"]}>
                <p><strong>{farm.subTitle}</strong></p>
                <p>{farm.description}</p>
              </div>

              <div className={styles["event-details-title"]}>Event Details:</div>
              <ul className={styles["details-list"]}>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Location:</span> {farm.location}
                </li>
                <li className={styles["details-item"]}>
                  <span className={styles["details-label"]}>Website:</span><br />
                  <a href={farm.webUrl} className={styles["website-link"]} target="_blank" rel="noopener noreferrer">
                    {farm.website}
                  </a>
                </li>
                {farm.details && farm.details.map((detail, dIdx) => {
                  const isHighlight = ["Good to Know", "Things to Do", "June Highlights", "Seasonal Preview", "Upcoming Activities", "Farmciti Pick! Moments We Loved", "Note"].includes(detail.label);
                  if (isHighlight) {
                    let contentItems = [];
                    if (detail.value.includes('|')) {
                      contentItems = detail.value.split('|').map(s => s.trim());
                    } else if ((detail.label === "Good to Know" || detail.label === "Farmciti Pick! Moments We Loved") && detail.value.includes(',')) {
                      // Also treat comma separated as list for these, if appropriate, but pipe is main separator in provided text.
                      // The provided text uses pipes.
                       contentItems = detail.value.split('|').map(s => s.trim());
                    } else {
                      contentItems = [detail.value];
                    }

                    return (
                      <li key={dIdx} className={styles["highlight-detail"]}>
                        <span className={styles["highlight-label"]}>{detail.label}</span>
                        <div className={styles["highlight-content"]}>
                          <ul className={styles["highlight-list"]}>
                            {contentItems.map((item, i) => (
                              <li key={i}>{item}</li>
                            ))}
                          </ul>
                        </div>
                      </li>
                    );
                  }
                  return (
                    <li key={dIdx} className={styles["details-item"]}>
                      <span className={styles["details-label"]}>{detail.label}:</span> {detail.value}
                    </li>
                  );
                })}
              </ul>
              <hr className={styles["farm-divider"]} />
            </div>
          ))}
        </div>
      ))}

      <div className={styles["lead-section"]}>
        <h2 className={styles["title"]} style={{ fontSize: '2rem', marginTop: '3rem' }}>Planning Your Spring Farm Visit?</h2>
        <p>Check each farm’s official website for hours, bloom updates, and ticket reservations. Many events sell out fast — especially Easter festivals and tulip picking days!</p>
      </div>
    </div>
  );
}
